import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import numberToWords from "number-to-words";

import {
  discountValidate,
  decimalValidate,
  decimalQtyValidate,
  dateConversion,
} from "../../../../components/Validation";

import { toast } from "react-toastify";
import Select from "react-select";
import SimpleMap from "../../../../components/gmaps";
import { useAuth } from "../../../../store/auth";

const PurchaseOrderForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [selectedExpectedDate, setSelectedExpectedDate] = useState();
  const handleDateChange = (e) => {
    //console.log("handleDateChange", e.target.value);
    setSelectedDate(e.target.value);
  };

  const handleExpectedDateChange = (e) => {
    setSelectedExpectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [discount, setDiscount] = useState(0);
  const { sendRequest: getVendor } = useHttp();
  const [docurl, setDocUrl] = useState(false);
  const [purchaseorderId, setpurchaseorderId] = useState(null);
  const [subTotalAmount, setSubTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [sameAdd, setSameAdd] = useState(false);
  const [billinglatLong, setBillinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [billingclose, setBillingclose] = useState(false);

  const [frieghtCharges, setfrieghtCharges] = useState();
  const [totalCostValue, setTotalCostValue] = useState(0);

  const [shippinglatLong, setShippinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [shippingclose, setShippingclose] = useState(false);
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [filterProducts, setFilterProducts] = useState();
  const [unitsData, setUnitsData] = useState();

  const [loading, setLoading] = useState(false);

  const [selectionType, setSelectionType] = useState([]);
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [editIndex, setEditIndex] = useState(-1);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxId, setTaxId] = useState();
  const [costInWords, setCostInWords] = useState(0);
  const [vendorId, setvendorId] = useState();

  const { tax, currency } = useAuth();

  const convertFloatToWords = (number) => {
    const words = numberToWords.toWords(number);
    const wordArray = words.split(" ");
    const decimalPart = Math.round(number * 100) % 100;
    if (decimalPart > 0) {
      const decimalWords = numberToWords.toWords(decimalPart);
      wordArray.push("and");
      wordArray.push(decimalWords);
    }

    return wordArray.join(" ");
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //  console.log(data);
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getLoadVendor } = useHttp();

  const { sendRequest: postPurchaseOrder } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    if (productDetails.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }

    setLoading(true);
    const data = {
      purchaseOrderDate: moment(frmRef.current.pdate.value).format(
        "DD/MM/YYYY"
      ),
      expectedDeliveryDate: moment(frmRef.current.excepted_date.value).format(
        "DD/MM/YYYY"
      ),
      vendorId: vendorId,
      supervisorEmployeeId: employeeId,
      currencyId: frmRef.current.currency.value,

      terms: frmRef.current.terms.value,
      billingAddress: frmRef.current.bill_address.value,
      billingCity: frmRef.current.bill_city.value,
      billingState: frmRef.current.bill_state.value,
      billingZip: frmRef.current.bill_zipcode.value,
      billingCountry: frmRef.current.bill_country.value,
      is_shippingSameBillingAdd: sameAdd,

      shippingAddress: frmRef.current.shipp_address.value,
      shippingCity: frmRef.current.shipp_city.value,
      shippingState: frmRef.current.shipp_state.value,
      shippingZip: frmRef.current.shipp_zopcode.value,
      shippingCountry: frmRef.current.Shipp_country.value,

      lineTotalAmount: subTotalAmount,
      totalAmount: totalAmount,
      discountPercentage: discount,
      discountAmount: (discount * subTotalAmount) / 100,
      frieghtCharges: frieghtCharges,
      taxId: frmRef.current.tax.value,
      taxAmount: taxAmount,
      totalPurchase: frmRef.current.total_cost.value,
      amountChargeable: frmRef.current.amt_chargeable.value,
      remark: frmRef.current.remark.value,
      productDetails: productDetails,
      status: 1,
      billinglatLong,
      shippinglatLong,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      //  //console.log("purchaseorderId", purchaseorderId);

      data["purchaseOrderId"] = purchaseorderId;
    }
    //  //console.log(data);
    postPurchaseOrder(
      {
        url: "/api/purchaseOrder/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Purchase Order ${props.update ? "Updated" : "Added"}`);

        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (close) {
      setTotalValue();
    }
  }, [productDetails, discount]);

  const { sendRequest: getProductDetails } = useHttp();

  useEffect(() => {
    //  //console.log("props.update", props.update);
    if (props.update) {
      setpurchaseorderId(props.update.purchaseOrderId);

      var purchaseOrderDate = dateConversion(
        props.update.purchaseOrderDate,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );
      var expectedDeliveryDate = dateConversion(
        props.update.expectedDeliveryDate,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );

      frmRef.current.pdate.value = props.update.purchaseOrderDate;
      frmRef.current.excepted_date.value = props.update.expectedDeliveryDate;

      setSelectedDate(purchaseOrderDate);

      setSelectedExpectedDate(expectedDeliveryDate);

      loadVendorData(props.update.vendorId);

      frmRef.current.contact_person_name.value = props.update.contactPersonName;
      frmRef.current.work_contact.value = props.update.contactWork;
      frmRef.current.whatsapp_contact.value = props.update.whatsapp;
      frmRef.current.email.value = props.update.email;
      frmRef.current.terms.value = props.update.terms;
      frmRef.current.bill_address.value = props.update.billingAddress;
      frmRef.current.bill_city.value = props.update.billingCity;
      frmRef.current.bill_state.value = props.update.billingState;
      frmRef.current.bill_zipcode.value = props.update.billingZip;
      frmRef.current.bill_country.value = props.update.billingCountry;

      frmRef.current.shipp_address.value = props.update.shippingAddress;
      frmRef.current.shipp_city.value = props.update.shippingCity;
      frmRef.current.shipp_state.value = props.update.shippingState;
      frmRef.current.shipp_zopcode.value = props.update.shippingZip;
      frmRef.current.Shipp_country.value = props.update.shippingCountry;

      setSubTotal(props.update.lineTotalAmount);

      setfrieghtCharges(props.update.frieghtCharges);
      //  frmRef.current.tax.value = props.update.taxId;
      setTaxAmount(props.update.taxAmount);
      ////  //console.log(props.update.taxAmount);

      setTaxId(props.update.taxId);
      // frmRef.current.tax_amt.value = props.update.taxAmount;
      frmRef.current.total_cost.value = props.update.totalPurchase;

      frmRef.current.amt_chargeable.value = props.update.amountChargeable;
      frmRef.current.remark.value = props.update.remark;

      getProductDetails(
        {
          url: `/api/purchaseOrderDetail/?purchaseOrderId=${props.update.purchaseOrderId}`,
        },
        (resData) => {
          if (resData) {
            var list = resData;

            setProductDetails(list);
          }
        }
      );

      setDiscount(props.update.discountPercentage);

      setBillinglatLong(
        props.update.billinglatLong || {
          lat: 18.644040659063442,
          lng: 73.72228501488648,
        }
      );
      setShippinglatLong(
        props.update.shippinglatLong || {
          lat: 18.644040659063442,
          lng: 73.72228501488648,
        }
      );
    }
  }, [props.update]);

  const loadVendorData = (id) => {
    setvendorId(id);
    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        if (res) {
          //   frmRef.current.vendor_id.value = res.vendorCode;
          frmRef.current.vendor_name.value = res.vendorName || "";
          frmRef.current.contact_person_name.value =
            res.contactPersonName || "";
          frmRef.current.work_contact.value = res.contactWork || "";
          frmRef.current.whatsapp_contact.value = res.whatsapp || "";
          frmRef.current.email.value = res.email || "";
        }
      }
    );
  };

  useEffect(() => {
    getVendor(
      {
        url: `/api/getVendorNames/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setVendorDetails(res);
        }
      }
    );
  }, [getVendor]);

  function setAddr() {
    frmRef.current.shipp_address.value = frmRef.current.bill_address.value;
    frmRef.current.shipp_city.value = frmRef.current.bill_city.value;
    frmRef.current.shipp_state.value = frmRef.current.bill_state.value;
    frmRef.current.shipp_zopcode.value = frmRef.current.bill_zipcode.value;
    frmRef.current.Shipp_country.value = frmRef.current.bill_country.value;
  }
  function clearAddr() {
    frmRef.current.shipp_address.value = "";
    frmRef.current.shipp_city.value = "";
    frmRef.current.shipp_state.value = "";
    frmRef.current.shipp_zopcode.value = "";
    frmRef.current.Shipp_country.value = "";
  }

  const setOfficeAddr = () => {
    if (frmRef.current.same_address.checked) {
      setAddr();
    } else {
      clearAddr();
    }
  };

  const submitProduct = (e) => {
    e.preventDefault();
    const productName = selectedProduct && selectedProduct.label;
    const itemTypeName = selectedType && selectedType.label;
    const itemSubTypeName = selectedSubType && selectedSubType.label;
    const itemQuantity = productRef.current.itemQuantity.value;
    const itemUnitPrice = productRef.current.itemUnitPrice.value;
    const rate = productRef.current.rate.value;
    const unit = selectedUnit && selectedUnit.label;

    if (
      !productName ||
      !itemTypeName ||
      !itemSubTypeName ||
      !itemQuantity ||
      !itemUnitPrice ||
      !rate ||
      !unit
    ) {
      toast.success("Please fill in all fields!");

      return;
    } else if (parseFloat(itemUnitPrice) < parseFloat(rate)) {
      toast.success("Please enter rate less than item unit price!");
    } else {
      const productName = selectedProduct && selectedProduct.label;
      const isDuplicate = productDetails.some(
        (product) => product.productName === productName
      );
      if (isDuplicate) {
        // alert('Item already exists!');
        toast.success("Item already exists!");

        return;
      }

      var lineAmount = (
        parseFloat(productRef.current.itemQuantity.value) *
        parseFloat(productRef.current.rate.value)
      ).toFixed(2);

      setProductDetails((x) => [
        ...x,
        {
          linesrNo: productDetails.length + 1,
          productId: selectedProduct && selectedProduct.value,
          productName: selectedProduct && selectedProduct.label,
          // itemDescription: productRef.current.item_description.value,
          productTypeName: selectedType && selectedType.label,
          productTypeId: selectedType && selectedType.value,
          productSubTypeName: selectedSubType && selectedSubType.label,
          productSubTypeId: selectedSubType && selectedSubType.value,
          orderQuantity: productRef.current.itemQuantity.value || 0,
          orderQuantityBalance: productRef.current.itemQuantity.value || 0,
          unitId: selectedUnit && selectedUnit.value,
          unitName: selectedUnit && selectedUnit.label,
          itemUnitPrice: productRef.current.itemUnitPrice.value || 0,
          rate: productRef.current.rate.value || 0,
          lineAmount: lineAmount,
          createdBy: parseInt(localStorage.getItem("id")),
          warehouseId: parseInt(localStorage.getItem("warehouseId")),
          orgId: localStorage.getItem("orgId"),
          status: 1,
        },
      ]);

      setSelectedUnit({});
      setSelectedProduct({});
      setSelectedSubType({});
      setSelectedType({});

      productRef.current.itemUnitPrice.value = 0;
      productRef.current.rate.value = 0;
      productRef.current.itemQuantity.value = 0;
    }
    // //console.log(productDetails);
  };

  const setTotalValue = () => {
    let acc = 0;
    productDetails.forEach((x) => {
      acc += x.rate * x.orderQuantity;
    });
    setSubTotal(acc);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const viewPdf = (e) => {
    e.preventDefault();
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
  };

  const handleBillingLatLong = () => {
    setBillingclose(true);
  };
  const handleShippingLatLong = () => {
    setShippingclose(true);
  };

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setUnitsData(res);
        }
      }
    );
    //console.log(props.sId);
  }, [getunits]);

  const { sendRequest: getItemType } = useHttp();

  useEffect(() => {
    getItemType(
      {
        //  url: `/api/productitemtypes/`,
        url: `/api/fillProductTypesWithoutServices/`,
      },
      (res) => {
        if (res) {
          ////  //console.log(res);
          setSelectionType(
            res.map((x) => ({
              value: x.productItemTypeId,
              label: x.productTypeName,
            }))
          );
          setSelectionSubType([]);
        }
      }
    );
  }, [getItemType]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(() => {
    getSubItem(
      {
        url: `/api/productsubitem/`,
      },
      (res) => {
        if (res) {
          ////  //console.log(res);
          setItemSubType(res);
        }
      }
    );
  }, [getSubItem]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/product/`,
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const handleTypeChange = (option) => {
    //console.log(option);
    setSelectedType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
    setSelectedSubType([]);
  };

  useEffect(
    (e) => {
      // //console.log(selectedType);
      const filteredData =
        itemSubType &&
        selectedType &&
        itemSubType.filter(
          (item) =>
            parseInt(item.productTypeId) ===
            parseInt(selectedType && selectedType.value)
        );

      setSelectionSubType(
        filteredData &&
          filteredData.map((x) => ({
            value: x.productSubTypeId,
            label: x.productSubTypeName,
          }))
      );
      // //console.log(filteredData);
      //
    },
    [selectedType]
  );

  //filter products

  const handleSubTypeChange = (option) => {
    setSelectedSubType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
  };

  useEffect(
    (e) => {
      //console.log(selectedSubType);
      const filteredProData =
        products &&
        products.filter(
          (item) =>
            parseInt(item.productSubTypeId) ===
            parseInt(selectedSubType && selectedSubType.value)
        );
      ////  //console.log(filteredProData);

      setFilterProducts(filteredProData);

      setSelectionProduct(
        filteredProData &&
          filteredProData.map((x) => ({
            value: x.productId,
            label: x.productName,
          }))
      );
    },
    [selectedSubType]
  );

  //filter units
  const handleProdcutChange = (option) => {
    if (option) {
      setSelectedProduct(option);
      setSelectedUnit([]);
    }
  };

  useEffect(
    (e) => {
      if (selectedProduct) {
        ////  //console.log(selectedProduct);
        const filteredUnitId =
          filterProducts &&
          filterProducts
            .filter(
              (item) =>
                parseInt(item.productId) ===
                parseInt(selectedProduct && selectedProduct.value)
            )
            .map((item) => item);

        ////  //console.log(filteredUnitId);

        if (selectedProduct.value) {
          const id = filteredUnitId && filteredUnitId[0].unitId; //unit id

          //  //  //console.log();

          const filteredUnits =
            unitsData &&
            unitsData
              .filter(
                (item) => parseInt(item.unitId) === parseInt(id) //filter unit type id
              )
              .map((item) => item.unitTypeId);

          const TypeId = (filteredUnits && filteredUnits[0]) || 0;

          const uData =
            unitsData &&
            unitsData.filter(
              (item) => parseInt(item.unitTypeId) === parseInt(TypeId) //filter all units
            );

          ////  //console.log(uData);

          setSelectionUnit(
            uData &&
              uData.map((x) => ({
                value: x.unitId,
                label: x.unitName,
              }))
          );
        }
      }
    },
    [selectedProduct]
  );
  const handleUnitChange = (option) => {
    //console.log(option);
    // {value: 9, label: 'Liquid fuel'}
    setSelectedUnit(option);
  };
  useEffect((e) => {}, [selectedUnit]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "200px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };

  const handleTaxChange = (e) => {
    setTaxId(e.target.value);
    // //console.log(e.target.value);
  };
  useEffect(() => {
    const filteredTaxPer =
      tax &&
      tax
        .filter((item) => parseInt(item.taxId) === parseInt(taxId))
        .map((item) => item.taxPercentage);

    var taxAmt = parseFloat((totalAmount / 100) * filteredTaxPer) || 0;
    taxAmt = taxAmt.toFixed(2);
    //  console.log(taxAmt);
    setTaxAmount(taxAmt);
  }, [taxId, totalAmount, productDetails, props.update]);

  useEffect(() => {
    setTotalCostValue(
      (
        parseFloat(totalAmount) +
          parseFloat(taxAmount) +
          parseFloat(frieghtCharges) || 0
      ).toFixed(2)
    );
  }, [totalAmount, taxAmount, frieghtCharges, taxId]);

  useEffect(() => {
    const totalCost1 = totalCostValue || 0;
    const totalCostInWords = convertFloatToWords(totalCost1);
    // console.log(totalCost1);
    setCostInWords(totalCostInWords);
  }, [totalCostValue]);

  useEffect(() => {
    setTotalAmount(
      parseFloat(subTotalAmount - (discount * subTotalAmount) / 100).toFixed(
        2
      ) || 0
    );
  }, [discount, subTotalAmount]);

  const onChange = (e) => {
    //  //console.log(`checked = ${e.target.checked}`);
    const flag = e.target.checked || false;
    setSameAdd(flag);
    if (flag == true) {
      setAddr();
    } else {
      clearAddr();
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Purchase Order Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                      <select
                        id="vendor_name"
                        className="form-control dropdowns"
                        required
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                        onChange={(e) => {
                          var vendorId =
                            e.target.childNodes[
                              e.target.selectedIndex
                            ].getAttribute("vendor-id");
                          // frmRef.current.vendor_id.value =
                          //   e.target.childNodes[e.target.selectedIndex].getAttribute(
                          //     "vendor-id"
                          //   );
                          loadVendorData(vendorId);
                        }}
                      >
                        <option selected disabled value="">
                          Select
                        </option>
                        {vendorDetails &&
                          vendorDetails.map((x) => (
                            <option
                              key={x.vendorId}
                              vendor-id={x.vendorId}
                              selected={
                                props.update &&
                                x.vendorId === props.update.vendorId
                              }
                            >
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}>
                        {" "}
                        {"Assign Employee"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId === props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {" "}
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(Work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {currency &&
                          currency.map((x) => (
                            <option
                              key={x.currencyId}
                              value={x.currencyId}
                              selected={
                                props.update &&
                                x.currencyId === props.update.currencyId
                              }
                            >
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"terms"}>{"Terms(if Any)"}</label>
                      <input
                        type={"text"}
                        id={"terms"}
                        ref={(el) => (frmRef.current["terms"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_address"}>
                        {" "}
                        {"Billing Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_address"}
                        required
                        ref={(el) => (frmRef.current["bill_address"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"bill_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"bill_city"}
                        required
                        ref={(el) => (frmRef.current["bill_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_state"}>
                        {" "}
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_state"}
                        required
                        ref={(el) => (frmRef.current["bill_state"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Zip Code (Postal Code)"}>
                        {" "}
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_zipcode"}
                        required
                        ref={(el) => (frmRef.current["bill_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"bill_country"}
                        required
                        ref={(el) => (frmRef.current["bill_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"billinglatLong"}> {"Lat/Long"}</label>
                      <br />
                      &nbsp;&nbsp;{" "}
                      <button
                        type="button"
                        id={"billinglatLong"}
                        onClick={(e) => {
                          handleBillingLatLong(e);
                        }}
                        ref={(el) => (frmRef.current["billinglatLong"] = el)}
                        className="btn-sm btn btn-warning"
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="form-check ">
                      <input
                        type={"checkbox"}
                        id={"same_address"}
                        ref={(el) => (frmRef.current["same_address"] = el)}
                        className="form-check-input"
                        onClick={onChange}
                      />
                      <label
                        htmlFor={"same_address"}
                        className="form-check-label"
                      >
                        {"Shipping Address same as  Billing Address"}
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Shipping Address"}>
                        {" "}
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"shipp_city"}
                        required
                        ref={(el) => (frmRef.current["shipp_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_state"}>
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_state"}
                        required
                        ref={(el) => (frmRef.current["shipp_state"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"shipp_zopcode"}>
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_zopcode"}
                        required
                        ref={(el) => (frmRef.current["shipp_zopcode"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Shipp_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"Shipp_country"}
                        required
                        ref={(el) => (frmRef.current["Shipp_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shippinglatLong"}> {"Lat/Long"}</label>
                      <br />
                      &nbsp;&nbsp;{" "}
                      <button
                        id={"shippinglatLong"}
                        type="button"
                        ref={(el) => (frmRef.current["shippinglatLong"] = el)}
                        className="btn btn-sm btn-warning"
                        onClick={(e) => {
                          handleShippingLatLong(e);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;{" "}
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.purchaseOrderDetailId > 0
                              )
                            );

                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                        placeholder="aaaas"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        disabled
                        value={totalAmount}
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        onChange={handleTaxChange}
                        required
                      >
                        <option value="">Select</option>
                        {tax &&
                          tax.map((x) => (
                            <option
                              key={x.taxId}
                              value={x.taxId}
                              selected={
                                props.update && x.taxId === props.update.taxId
                              }
                            >
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        onChange={(e) => setTaxAmount(e.target.value)}
                        value={taxAmount}
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"number"}
                        id={"frieght_charges"}
                        required
                        // ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        value={frieghtCharges}
                        onChange={(e) => {
                          decimalQtyValidate(e);

                          setfrieghtCharges(e.target.value);
                        }}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        disabled
                        value={totalCostValue}
                        //value={ parseFloat(frmRef.current.total_amt.value) + parseFloat(frieghtCharges)+parseFloat(taxAmount) }
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date"}>
                        {" "}
                        {"Expected Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["excepted_date"] = el)}
                        className="form-control"
                        min={selectedDate}
                        value={selectedExpectedDate}
                        onChange={handleExpectedDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <textarea
                        // type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        //className="form-control currancy-value"
                        value={costInWords}
                        rows="2"
                        cols="27"
                        style={{ resize: "none" }}
                        disabled
                      ></textarea>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {billingclose && (
        <Modal onClose={setBillingclose} isOpen={true} style={modalStyles}>
          <div className="text-center">
            <SimpleMap
              lat={billinglatLong.lat}
              lng={billinglatLong.lng}
              set={setBillinglatLong}
              close={setBillingclose}
              className="text-center"
            />
          </div>
        </Modal>
      )}
      {shippingclose && (
        <Modal onClose={setShippingclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={shippinglatLong.lat}
            lng={shippinglatLong.lng}
            set={setShippinglatLong}
            close={setShippingclose}
          />
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"itemType"}>Item Type</label>

              <Select
                styles={customStyles}
                options={selectionType}
                value={selectedType}
                onChange={(option) => {
                  handleTypeChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3 ">
              <label htmlFor={"itemCategory"}> Item Category</label>

              <Select
                styles={customStyles}
                options={selectionSubType}
                value={selectedSubType}
                onChange={(option) => {
                  handleSubTypeChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemDescription"}> Item Description</label>

              <Select
                styles={customStyles}
                options={selectionProduct}
                value={selectedProduct}
                onChange={(option) => {
                  handleProdcutChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemUnitPrice"}>Item Unit Price</label>
              <input
                type={"number"}
                id={"itemUnitPrice"}
                required
                ref={(el) => (productRef.current["itemUnitPrice"] = el)}
                className="form-control"
                onChange={(e) => e.target.value}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"rate"}>Rate</label>
              <input
                type={"number"}
                id={"rate"}
                required
                ref={(el) => (productRef.current["rate"] = el)}
                className="form-control"
                onChange={(e) => e.target.value}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemQuantity"}> Item Quantity</label>
              <input
                type={"number"}
                id={"itemQuantity"}
                required
                ref={(el) => (productRef.current["itemQuantity"] = el)}
                className="form-control"
                onChange={(e) => e.target.value}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"unit"}> Unit</label>

              <Select
                styles={customStyles}
                options={selectionUnit}
                value={selectedUnit}
                onChange={(option) => {
                  handleUnitChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <br />
              <button className="btn btn-success" onClick={submitProduct}>
                +
              </button>
            </div>
          </div>
          <hr />
          <div className="leftpanelscroll">
            <table className="table table-bordered table-sm table-">
              <thead className="">
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Item Type</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  {/* <th>Edit</th> */}
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrNo}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{parseFloat(itm.itemUnitPrice).toFixed(2)}</td>
                        <td>{parseFloat(itm.rate).toFixed(2)}</td>
                        <td>{parseFloat(itm.orderQuantity).toFixed(2)}</td>
                        <td>{itm.unitName}</td>
                        <td>{itm.lineAmount}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"subTotalAmount"}>Sub-total Amount</label>
              <input
                type={"number"}
                id={"subTotalAmount"}
                value={parseFloat(subTotalAmount).toFixed(2)}
                // ref={(el) => (productRef.current["subTotalAmount"] = el)}
                className="form-control currancy-value"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount(%)</label>
              <input
                type={"number"}
                id={"discount"}
                required
                onChange={(e) => {
                  var _discount = e.target.value ?? 0;
                  if (!discountValidate(_discount)) {
                    _discount = 0;
                    e.target.value = 0;
                  }
                  setDiscount(_discount);
                }}
                value={discount}
                // ref={(el) => (productRef.current["discount"] = el)}
                className="form-control currancy-value"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discounted Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                disabled
                value={((discount * subTotalAmount) / 100).toFixed(2)}
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control currancy-value"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total Amount</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                disabled
                value={totalAmount}
                ref={(el) => (productRef.current["totalAmount"] = el)}
                className="form-control  currancy-value"
              />
            </div>
          </div>

          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                //  //console.log("productDetails", productDetails);

                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));

                //  //console.log(productDetails);
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};
export default PurchaseOrderForm;
